const random = (array) => array[Math.floor((Math.random() * array.length))];

export const FAKE_PROJECTS = [ 
  { label: "ABATA", value: "PLWDRDKI" },
  { label: "ABATZ", value: "MVGTJPLK" },
  { label: "AGIMBA", value: "OCDCIPML" },
  { label: "AGIVU", value: "TJIFIGUR" },
  { label: "AIBOX", value: "MAZLALFI" },
  { label: "AILANE", value: "QTRIHHXC" },
  { label: "AIMBO", value: "EEZNCYIF" },
  { label: "AIMBU", value: "NCVLXXJP" },
  { label: "AINYX", value: "OFAIIPXC" },
  { label: "AIVEE", value: "LUUYJKPL" },
  { label: "AVAMBA", value: "YTNOCZGX" },
  { label: "AVAMM", value: "PKJQSBCO" },
  { label: "AVAVEE", value: "OSDYAMRS" },
  { label: "AVAVEO", value: "AOZDMXAR" },
  { label: "BABBLEBLAB", value: "NEMZPLZN" },
  { label: "BABBLEOPIA", value: "PMMVSEDJ" },
  { label: "BABBLESET", value: "RZDWHPRW" },
  { label: "BABBLESTORM", value: "BHFSVSXV" },
  { label: "BLOGNATION", value: "DJYOTOYC" },
  { label: "BLOGPAD", value: "SCQVHTTB" },
  { label: "BLOGSPAN", value: "TXPGIVJR" },
  { label: "BLOGTAG", value: "XSWQBTSN" },
  { label: "BLOGTAGS", value: "WRJXWVMQ" },
  { label: "BLOGXS", value: "DIPXPYJR" },
  { label: "BLUEJAM", value: "PREJQHUN" },
  { label: "BLUEZOOM", value: "ATJSWMTY" },
  { label: "BRAINBOX", value: "WPYFRWBO" },
  { label: "BRAINLOUNGE", value: "BKURVLYB" },
  { label: "BRAINSPHERE", value: "HPZMGAUU" },
  { label: "BRAINVERSE", value: "CHKNASMK" },
  { label: "BRIGHTBEAN", value: "SQYBRCUV" },
  { label: "BRIGHTDOG", value: "IJKULHHS" },
  { label: "BROWSEBLAB", value: "LTSRFUJQ" },
  { label: "BROWSEBUG", value: "NCAZSPUE" },
  { label: "BROWSECAT", value: "OYWCKPKP" },
  { label: "BROWSEDRIVE", value: "KBSSLNHL" },
  { label: "BROWSETYPE", value: "MWCNPXYU" },
  { label: "BROWSEZOOM", value: "MKCIXCKH" },
  { label: "BUBBLEBOX", value: "RFYBQXVV" },
  { label: "BUBBLEMIX", value: "VSNOUBEF" },
  { label: "BUBBLETUBE", value: "WAAWXARJ" },
  { label: "BUZZBEAN", value: "JWOTNBZK" },
  { label: "BUZZDOG", value: "JLDFRQFK" },
  { label: "BUZZSHARE", value: "JSFYMOXZ" },
  { label: "BUZZSTER", value: "NPXTLVQO" },
  { label: "CAMIDO", value: "AFRJUTML" },
  { label: "CAMIMBO", value: "QTPLVNKQ" },
  { label: "CENTIDEL", value: "MQFMBYIJ" },
  { label: "CENTIMIA", value: "ZVACLXEM" },
  { label: "CENTIZU", value: "ZEISNVLK" },
  { label: "CHATTERBRIDGE", value: "EZYWJZBC" },
  { label: "CHATTERPOINT", value: "KTEYQLMN" },
  { label: "COGIBOX", value: "RSPLLLEZ" },
  { label: "COGIDOO", value: "VCHVJAIH" },
  { label: "COGILITH", value: "TUMSDYDO" },
  { label: "DABFEED", value: "OYITJHZV" },
  { label: "DABJAM", value: "IWJTMDII" },
  { label: "DABLIST", value: "JULTAYRQ" },
  { label: "DABSHOTS", value: "NCOYNSYP" },
  { label: "DABTYPE", value: "VLQWTJEV" },
  { label: "DABVINE", value: "CCOINWMD" },
  { label: "DABZ", value: "BJHOSULO" },
  { label: "DAZZLESPHERE", value: "HDTHZROL" },
  { label: "DEMIMBU", value: "SRFPSGLV" },
  { label: "DEMIVEE", value: "YKLKOKVY" },
  { label: "DEMIZZ", value: "DYWAHIHH" },
  { label: "DEVBUG", value: "TAESGDDS" },
  { label: "DEVCAST", value: "UWOJCTPT" },
  { label: "DEVIFY", value: "WPIZBMFE" },
  { label: "DEVPOINT", value: "ZLJIPMYF" },
  { label: "DEVPULSE", value: "USVLOZCI" },
  { label: "DEVSHARE", value: "WDVLVVYY" },
  { label: "DIGITUBE", value: "HDFSCFLW" },
  { label: "DIVANOODLE", value: "LMHARCHI" },
  { label: "DIVAPE", value: "WQWTZQLC" },
  { label: "DIVAVU", value: "HYCSEHWZ" },
  { label: "DYNABOX", value: "EXRNVENK" },
  { label: "DYNAVA", value: "AXPQEYUJ" },
  { label: "DYNAZZY", value: "BRTNQRAR" },
  { label: "EABOX", value: "HBSOEQUJ" },
  { label: "EADEL", value: "KCKONABI" },
  { label: "EAMIA", value: "DWGPNHTJ" },
  { label: "EARE", value: "QRRFDUWG" },
  { label: "EAYO", value: "EJLPTXSJ" },
  { label: "EAZZY", value: "CVMWBGIE" },
  { label: "EDGEBLAB", value: "OIHVFRQM" },
  { label: "EDGECLUB", value: "BKUPRIMI" },
  { label: "EDGEIFY", value: "RMWLBFGS" },
  { label: "EDGEPULSE", value: "SZMCCCSE" },
  { label: "EDGETAG", value: "NCFTFXEV" },
  { label: "EDGEWIRE", value: "MKOOLHYO" },
  { label: "EIDEL", value: "DTTLWVFO" },
  { label: "EIMBEE", value: "QZXMJGAA" },
  { label: "EINTI", value: "EKDZBPXE" },
  { label: "EIRE", value: "ZNWVUAML" },
  { label: "FADEO", value: "YUAOPTPC" },
  { label: "FANOODLE", value: "CSLLZRPU" },
  { label: "FATZ", value: "RVGZFCGV" },
  { label: "FEEDBUG", value: "RYLURZNG" },
  { label: "FEEDFIRE", value: "SMIBWOBJ" },
  { label: "FEEDFISH", value: "VBFOSHTO" },
  { label: "FEEDMIX", value: "OXAALEVJ" },
  { label: "FEEDNATION", value: "GTEGTOZP" },
  { label: "FEEDSPAN", value: "NQHJQFBC" },
  { label: "FIVEBRIDGE", value: "ZWCCHWZG" },
  { label: "FIVECHAT", value: "BDLWZWWH" },
  { label: "FIVECLUB", value: "BZFFVWTL" },
  { label: "FIVESPAN", value: "GUPVKVJL" },
  { label: "FLASHDOG", value: "SPYAOTFL" },
  { label: "FLASHPOINT", value: "KQHQUIIC" },
  { label: "FLASHSET", value: "MCMTZKTR" },
  { label: "FLASHSPAN", value: "ZALMTLZU" },
  { label: "FLIPBUG", value: "FHYPZQGE" },
  { label: "FLIPOPIA", value: "YWNMZLGU" },
  { label: "FLIPSTORM", value: "GARQAAHB" },
  { label: "FLIPTUNE", value: "ASXUJSVN" },
  { label: "GABCUBE", value: "EEUISLUP" },
  { label: "GABSPOT", value: "OONJYQAU" },
  { label: "GABTUNE", value: "OUWFOOLX" },
  { label: "GABTYPE", value: "KIWNLXQT" },
  { label: "GABVINE", value: "BMCRZXYV" },
  { label: "GEBA", value: "AIFASWUR" },
  { label: "GEVEE", value: "PGNFNSCY" },
  { label: "GEVEE", value: "BETLYLOG" },
  { label: "GIGABOX", value: "FHOUJPKW" },
  { label: "GIGACLUB", value: "AQPNICLZ" },
  { label: "GIGASHOTS", value: "PDXLFTOZ" },
  { label: "GIGAZOOM", value: "DFLDXXGA" },
  { label: "INNOJAM", value: "IFKHCLTC" },
  { label: "INNOTYPE", value: "RLWDVIEA" },
  { label: "INNOZ", value: "FMKQUJOT" },
  { label: "IZIO", value: "HVSUQQFI" },
  { label: "JABBERBEAN", value: "SIKFGTRJ" },
  { label: "JABBERCUBE", value: "TZTEWFRN" },
  { label: "JABBERSPHERE", value: "VTRDJJPV" },
  { label: "JABBERSTORM", value: "XROACODE" },
  { label: "JABBERTYPE", value: "IVKOBWKM" },
  { label: "JALOO", value: "WQTRVYJQ" },
  { label: "JAMIA", value: "VJZWKNIB" },
  { label: "JANYX", value: "LHJMDBZK" },
  { label: "JATRI", value: "MUNFHZWF" },
  { label: "JAXBEAN", value: "XSNGCATM" },
  { label: "JAXNATION", value: "VMOYBJTU" },
  { label: "JAXSPAN", value: "TBHYUQOF" },
  { label: "JAXWORKS", value: "UBISMVXZ" },
  { label: "JAYO", value: "DBYVJYOB" },
  { label: "JAZZY", value: "ZBULEXNG" },
  { label: "JETPULSE", value: "EXKSMUNC" },
  { label: "JETWIRE", value: "LZIZBPTR" },
  { label: "JUMPXS", value: "RCSLZCHC" },
  { label: "KAMBA", value: "HINKZKGP" },
  { label: "KANOODLE", value: "BAERNTVP" },
  { label: "KARE", value: "VDCEWRFK" },
  { label: "KATZ", value: "PJJACMEQ" },
  { label: "KAYMBO", value: "WRIGZGRP" },
  { label: "KAYVEO", value: "XVOCBGYB" },
  { label: "KAZIO", value: "KFNLIKWF" },
  { label: "KAZU", value: "KLOFBNTY" },
  { label: "KIMIA", value: "FLVZNSCI" },
  { label: "KWIDEO", value: "POKDRHEJ" },
  { label: "KWILITH", value: "FSGQSUNZ" },
  { label: "KWIMBEE", value: "BSPCRUXI" },
  { label: "KWINU", value: "MUZPXQOE" },
  { label: "LAJO", value: "WEQYLAYW" },
  { label: "LATZ", value: "CUWELNIF" },
  { label: "LAYO", value: "MDMXLWIT" },
  { label: "LAZZ", value: "THHCSHFJ" },
  { label: "LAZZY", value: "LAQFIJYA" },
  { label: "LEENTI", value: "ZYDUILDR" },
  { label: "LEEXO", value: "TZGBWCRW" },
  { label: "LINKBRIDGE", value: "KWDFECMZ" },
  { label: "LINKBUZZ", value: "HTMBMZRE" },
  { label: "LINKLINKS", value: "GXJKAOVI" },
  { label: "LINKTYPE", value: "KQHPTHYO" },
  { label: "LIVEFISH", value: "HMBCGPLN" },
  { label: "LIVEPATH", value: "AZFUKWKL" },
  { label: "LIVETUBE", value: "WIRSZSLA" },
  { label: "LIVEZ", value: "RNPHKQSV" },
  { label: "MEEDOO", value: "CZCHEYAW" },
  { label: "MEEJO", value: "CFBTIHTM" },
  { label: "MEEMBEE", value: "RSGCDLSH" },
  { label: "MEEMM", value: "VOBFBKIO" },
  { label: "MEETZ", value: "MVWFLXJY" },
  { label: "MEEVEE", value: "DMWYOMVE" },
  { label: "MEEVEO", value: "VZOLVRAD" },
  { label: "MEEZZY", value: "IHTNBRKJ" },
  { label: "MIBOO", value: "PXCIKNCO" },
  { label: "MIDEL", value: "DEIYMKKL" },
  { label: "MINYX", value: "ZJWVINZW" },
  { label: "MITA", value: "JLFJCIXG" },
  { label: "MUDO", value: "EITQIAPD" },
  { label: "MUXO", value: "XVCRGPMC" },
  { label: "MYBUZZ", value: "MHEIYDNU" },
  { label: "MYCAT", value: "VWSPQNMM" },
  { label: "MYDEO", value: "UDILQKEO" },
  { label: "MYDO", value: "CXICRZGO" },
  { label: "MYMM", value: "WZUWLMGA" },
  { label: "MYNTE", value: "WCMPBSVI" },
  { label: "MYWORKS", value: "JGFKMLNY" },
  { label: "NLOUNGE", value: "TQUBTMRQ" },
  { label: "NPATH", value: "WHMWGZSI" },
  { label: "NTAG", value: "XJEXAKWW" },
  { label: "NTAGS", value: "EYXASGXJ" },
  { label: "OBA", value: "LQFDWZMI" },
  { label: "OLOO", value: "XNUDVMTU" },
  { label: "OMBA", value: "EGXERUCS" },
  { label: "OOBA", value: "IZGOHHLQ" },
  { label: "OODOO", value: "NWNHBARR" },
  { label: "OOZZ", value: "KHGRSXOT" },
  { label: "OYOBA", value: "VMTXBRUY" },
  { label: "OYOLOO", value: "AEWWQXKE" },
  { label: "OYONDER", value: "OIDRJPTJ" },
  { label: "OYONDU", value: "UBVHDBIJ" },
  { label: "OYOPE", value: "HTVEFFJP" },
  { label: "OYOYO", value: "QFGBSINT" },
  { label: "OZU", value: "KVINAZVQ" },
  { label: "PHOTOBEAN", value: "BEYOCLCP" },
  { label: "PHOTOBUG", value: "MNUMQRRW" },
  { label: "PHOTOFEED", value: "IMGIOIEE" },
  { label: "PHOTOJAM", value: "QUJTUJEC" },
  { label: "PHOTOLIST", value: "AMZPOBLY" },
  { label: "PHOTOSPACE", value: "GQYMMFDK" },
  { label: "PIXOBOO", value: "ZTCUJZVG" },
  { label: "PIXONYX", value: "VDXZFVJK" },
  { label: "PIXOPE", value: "IGOPBCMD" },
  { label: "PLAJO", value: "KIOUUSEN" },
  { label: "PLAMBEE", value: "TDYCWPCJ" },
  { label: "PODCAT", value: "TUFAYANC" },
  { label: "QUAMBA", value: "DTQZPUHY" },
  { label: "QUATZ", value: "GVEUVNNT" },
  { label: "QUAXO", value: "GRZMNHHL" },
  { label: "QUIMBA", value: "STMZZXPI" },
  { label: "QUIMM", value: "BFZYFFBC" },
  { label: "QUINU", value: "RIZIKEIQ" },
  { label: "QUIRE", value: "UFVGZYKQ" },
  { label: "REALBLAB", value: "USARZOWT" },
  { label: "REALBRIDGE", value: "QQHEEZNV" },
  { label: "REALBUZZ", value: "ONXOBJON" },
  { label: "REALCUBE", value: "QERVDYRA" },
  { label: "REALFIRE", value: "FYTUMDVF" },
  { label: "REALLINKS", value: "PJQWDBEX" },
  { label: "REALMIX", value: "ZOYTNLGM" },
  { label: "REALPOINT", value: "MJSJOVRQ" },
  { label: "RHYBOX", value: "MYGLIIXP" },
  { label: "RHYCERO", value: "BAQJPQNF" },
  { label: "RHYLOO", value: "NVQBRMWW" },
  { label: "RHYNOODLE", value: "NTIOUGRZ" },
  { label: "RHYNYX", value: "WJEWSKIL" },
  { label: "RHYZIO", value: "VHTZEULQ" },
  { label: "RIFFPATH", value: "OQCEEWLF" },
  { label: "RIFFPEDIA", value: "UDJKMSXA" },
  { label: "RIFFWIRE", value: "KQKORVUA" },
  { label: "ROODEL", value: "UQOQRIIU" },
  { label: "ROOMBO", value: "PCJJNFZC" },
  { label: "ROOMM", value: "MBNDTFVT" },
  { label: "ROOXO", value: "NXOQIFLV" },
  { label: "SHUFFLEBEAT", value: "ACDXRMNW" },
  { label: "SHUFFLEDRIVE", value: "ITVYLXPS" },
  { label: "SHUFFLESTER", value: "GOLTPHMF" },
  { label: "SHUFFLETAG", value: "ATAWBXGN" },
  { label: "SKABOO", value: "GEDONVMJ" },
  { label: "SKAJO", value: "HPIJCHAV" },
  { label: "SKALITH", value: "IYGBYMPB" },
  { label: "SKIBA", value: "MWKMWXJQ" },
  { label: "SKIBOX", value: "ZKINWZFW" },
  { label: "SKIDOO", value: "TPLRKZRM" },
  { label: "SKILITH", value: "DNQFCJDM" },
  { label: "SKIMIA", value: "OBSUSQKL" },
  { label: "SKINDER", value: "WJRNSLHW" },
  { label: "SKINIX", value: "HTARJBZV" },
  { label: "SKINTE", value: "DLCSXGHZ" },
  { label: "SKIPFIRE", value: "GVTAPQNR" },
  { label: "SKIPPAD", value: "YFQXXFLN" },
  { label: "SKIPSTORM", value: "WPBIGNVW" },
  { label: "SKIPTUBE", value: "MOKBFXZA" },
  { label: "SKIVEE", value: "DGFFEKXH" },
  { label: "SKYBA", value: "YUOMFUOJ" },
  { label: "SKYBLE", value: "HDIVXIOF" },
  { label: "SKYNDU", value: "DXVMXLAA" },
  { label: "SKYNOODLE", value: "TTEUQECG" },
  { label: "SKYVU", value: "PAXFVVGF" },
  { label: "SNAPTAGS", value: "JPMDCZNY" },
  { label: "TAGCAT", value: "BXIXKZNW" },
  { label: "TAGCHAT", value: "TUGPHTZJ" },
  { label: "TAGFEED", value: "WAMCKXWY" },
  { label: "TAGOPIA", value: "EGLATLFH" },
  { label: "TAGPAD", value: "TTXOUPXA" },
  { label: "TAGTUNE", value: "HVWKTFLB" },
  { label: "TALANE", value: "ESTWPLWD" },
  { label: "TAMBEE", value: "MCMQEWNM" },
  { label: "TANOODLE", value: "HMWVGWPX" },
  { label: "TAVU", value: "FZQYERHC" },
  { label: "TAZZ", value: "WQGUCGFX" },
  { label: "TAZZY", value: "VUVJMHDN" },
  { label: "TEKFLY", value: "TRBCDXWD" },
  { label: "TEKLIST", value: "KSONPDVJ" },
  { label: "THOUGHTBEAT", value: "HSOKBOOW" },
  { label: "THOUGHTBLAB", value: "AFPQSQSZ" },
  { label: "THOUGHTBRIDGE", value: "KAIKMYMW" },
  { label: "THOUGHTMIX", value: "DXHWFGZU" },
  { label: "THOUGHTSPHERE", value: "GBWMKQLQ" },
  { label: "THOUGHTSTORM", value: "HNHSGGHS" },
  { label: "THOUGHTWORKS", value: "ANNGCFRY" },
  { label: "TOPDRIVE", value: "CHMWQBPY" },
  { label: "TOPICBLAB", value: "CVFOAPTT" },
  { label: "TOPICLOUNGE", value: "MPBIZVJS" },
  { label: "TOPICSHOTS", value: "FWBMARTJ" },
  { label: "TOPICSTORM", value: "AOCLDXTW" },
  { label: "TOPICWARE", value: "FUQXZFXO" },
  { label: "TOPICZOOM", value: "QFYRREJW" },
  { label: "TRILIA", value: "RKYZPXBI" },
  { label: "TRILITH", value: "QVNFAZAY" },
  { label: "TRUDEO", value: "EJMFCUBS" },
  { label: "TRUDOO", value: "XLDCGYWS" },
  { label: "TRUNYX", value: "LAILXUMW" },
  { label: "TRUPE", value: "FRBJVJUP" },
  { label: "TWIMBO", value: "AFVKWROH" },
  { label: "TWIMM", value: "CTGTZMWF" },
  { label: "TWINDER", value: "CQLGBFOP" },
  { label: "TWINTE", value: "RWCJSOKC" },
  { label: "TWITTERBEAT", value: "PCRLXICG" },
  { label: "TWITTERBRIDGE", value: "WPSRXNZQ" },
  { label: "TWITTERLIST", value: "IHHCJAZR" },
  { label: "TWITTERNATION", value: "YYIVPOSI" },
  { label: "TWITTERWIRE", value: "URDBJZAN" },
  { label: "TWITTERWORKS", value: "AFXFXCYE" },
  { label: "TWIYO", value: "WROXSTQJ" },
  { label: "VIDOO", value: "EHEENHBO" },
  { label: "VIMBO", value: "WFVOZISM" },
  { label: "VINDER", value: "QLPBFEQY" },
  { label: "VINTE", value: "ZDDOUJAZ" },
  { label: "VIPE", value: "ETYOYRTI" },
  { label: "VITZ", value: "SLGOKMQB" },
  { label: "VIVA", value: "SNAAQNPO" },
  { label: "VOOLIA", value: "TGHSKAOP" },
  { label: "VOOLITH", value: "MKHNZIHB" },
  { label: "VOOMM", value: "BITWQRVE" },
  { label: "VOONDER", value: "BXIQRLBX" },
  { label: "VOONIX", value: "ETXNRXSW" },
  { label: "VOONTE", value: "VKEXRHPY" },
  { label: "VOONYX", value: "WVEGEZEV" },
  { label: "WIKIBOX", value: "TXWDZQNE" },
  { label: "WIKIDO", value: "TGZKOANS" },
  { label: "WIKIVU", value: "GSNKJTKS" },
  { label: "WIKIZZ", value: "OPWBGGNQ" },
  { label: "WORDIFY", value: "MPJAQXSK" },
  { label: "WORDPEDIA", value: "KAQZTWPF" },
  { label: "WORDTUNE", value: "PYGRXBKK" },
  { label: "WORDWARE", value: "IZBFGREW" },
  { label: "YABOX", value: "ROGCHYEI" },
  { label: "YACERO", value: "CUOQIJPJ" },
  { label: "YADEL", value: "NDPUWHRD" },
  { label: "YAKIDOO", value: "JPGVZUZW" },
  { label: "YAKIJO", value: "XQXCPFID" },
  { label: "YAKITRI", value: "XMGKVPMV" },
  { label: "YAMBEE", value: "BJMHZBVZ" },
  { label: "YAMIA", value: "EDGEUCTH" },
  { label: "YATA", value: "ETBKKMUI" },
  { label: "YODEL", value: "HDHWOLTR" },
  { label: "YODO", value: "QVSUHLLN" },
  { label: "YODOO", value: "XHSEZYNL" },
  { label: "YOMBU", value: "ASZCBYUL" },
  { label: "YOTZ", value: "OMQSYPRG" },
  { label: "YOUBRIDGE", value: "PKHTOPCX" },
  { label: "YOUFEED", value: "LKGNDFSJ" },
  { label: "YOUOPIA", value: "AXRIRSIW" },
  { label: "YOUSPAN", value: "ZWXRRFTA" },
  { label: "YOUTAGS", value: "ILRKJOZK" },
  { label: "YOVEO", value: "ZFUEGFOM" },
  { label: "YOZIO", value: "ZCKNNTKO" },
  { label: "ZAVA", value: "BYPFFPUB" },
  { label: "ZAZIO", value: "NQCLODXK" },
  { label: "ZOOMBEAT", value: "CUVIEJJL" },
  { label: "ZOOMBOX", value: "DKSVBRMV" },
  { label: "ZOOMCAST", value: "AQOJVFIF" },
  { label: "ZOOMDOG", value: "PUVVNQQY" },
  { label: "ZOOMLOUNGE", value: "AFQDTARV" },
  { label: "ZOOMZONE", value: "OSVENIOG" },
  { label: "ZOONDER", value: "UQYPZHVP" },
  { label: "ZOONOODLE", value: "XMKNGPJS" },
  { label: "ZOOVEO", value: "CJUJFGTA" },
  { label: "ZOOVU", value: "KUBVZXSI" },
  { label: "ZOOXO", value: "OLWISSAL" },
  { label: "ZOOZZY", value: "XBBHZOSS" }
];

export const FAKE_MATERIALS = [
  { partNum: "AR01-5P8S", desc: "Roe - Lump Fish, Red" },
  { partNum: "CUJ9-TJWG", desc: "Brownies - Two Bite, Chocolate" },
  { partNum: "QDW5-9MK8", desc: "Energy Drink" },
  { partNum: "MTSL-3YNX", desc: "Crab - Claws, 26 - 30" },
  { partNum: "IIVW-ISMI", desc: "Carrots - Purple, Organic" },
  { partNum: "Y087-YT3C", desc: "Glaze - Apricot" },
  { partNum: "MRNH-BHRE", desc: "Chevere Logs" },
  { partNum: "BXTX-FS2U", desc: "Shichimi Togarashi Peppeers" },
  { partNum: "0BTP-LVCK", desc: "Persimmons" },
  { partNum: "US36-0J89", desc: "Coffee - Almond Amaretto" },
  { partNum: "9R62-562R", desc: "Pasta - Angel Hair" },
  { partNum: "CTA5-ACXW", desc: "Ice Cream - Vanilla" },
  { partNum: "EPD3-6RN0", desc: "Chocolate Eclairs" },
  { partNum: "9B4L-Y77R", desc: "Water - Spring Water 500ml" },
  { partNum: "JRXQ-B04K", desc: "Madeira" },
  { partNum: "47H1-PFUJ", desc: "Sping Loaded Cup Dispenser" },
  { partNum: "9RGR-D0LM", desc: "Quinoa" },
  { partNum: "4R5F-HJZ3", desc: "Tomatoes - Cherry" },
  { partNum: "FWH0-SCR5", desc: "Beef - Texas Style Burger" },
  { partNum: "4NOY-SJ16", desc: "Bread - Wheat Baguette" },
  { partNum: "MBWI-98QV", desc: "Cheese - Mascarpone" },
  { partNum: "9WMP-VP91", desc: "Melon - Cantaloupe" },
  { partNum: "I13F-0XKD", desc: "Crackers - Graham" },
  { partNum: "5QCV-VQ4X", desc: "Nut - Almond, Blanched, Sliced" },
  { partNum: "WOAD-87SC", desc: "Vodka - Lemon, Absolut" },
  { partNum: "VWDA-PCCC", desc: "Wine - Rubyport" },
  { partNum: "A0NR-AXWX", desc: "Fondant - Icing" },
  { partNum: "9KEY-HFRD", desc: "Petit Baguette" },
  { partNum: "DDS2-RAKD", desc: "Yogurt - Cherry, 175 Gr" },
  { partNum: "CWJ8-BQGY", desc: "Truffle - Peelings" },
  { partNum: "RTQM-IONQ", desc: "Country Roll" },
  { partNum: "KC8U-0AS1", desc: "Towels - Paper / Kraft" },
  { partNum: "PIIV-ZG02", desc: "Extract - Almond" },
  { partNum: "OJNY-ZNDH", desc: "Sausage - Meat" },
  { partNum: "JDGK-VBJ7", desc: "Juice - Apple, 500 Ml" },
  { partNum: "H193-BNK3", desc: "Cornstarch" },
  { partNum: "G79H-PG0Y", desc: "Gatorade - Orange" },
  { partNum: "ND40-70OF", desc: "Tart Shells - Sweet, 3" },
  { partNum: "3BTB-3U91", desc: "Poppy Seed" },
  { partNum: "DX7F-J8WR", desc: "Magnotta Bel Paese Red" },
  { partNum: "FLJ0-OXX6", desc: "Chicken - Base, Ultimate" },
  { partNum: "UF8T-YMBR", desc: "Lettuce - Green Leaf" },
  { partNum: "TI0S-7WR6", desc: "Egg - Salad Premix" },
  { partNum: "LH6O-IAWD", desc: "Vegetable - Base" },
  { partNum: "1DDF-MYHX", desc: "Napkin - Cocktail,beige 2 - Ply" },
  { partNum: "7VCB-8LX7", desc: "Silicone Parch. 16.3x24.3" },
  { partNum: "UIXQ-4KZ3", desc: "Table Cloth 144x90 White" },
  { partNum: "JP76-NDX4", desc: "Molasses - Fancy" },
  { partNum: "2WLS-G33R", desc: "Peppercorns - Green" },
  { partNum: "3TVD-5LOD", desc: "Beef - Rouladin, Sliced" },
  { partNum: "MBOU-NRMF", desc: "Crab - Blue, Frozen" },
  { partNum: "2DT0-DG9Y", desc: "Snapple - Mango Maddness" },
  { partNum: "G5PR-TT6H", desc: "Wine - Jackson Triggs Okonagan" },
  { partNum: "HJZS-2S1T", desc: "Chips Potato Salt Vinegar 43g" },
  { partNum: "Q8T3-BM9C", desc: "Jam - Marmalade, Orange" },
  { partNum: "CFI5-E5TA", desc: "Pop - Club Soda Can" },
  { partNum: "MVKM-HXMN", desc: "Grapefruit - Pink" },
  { partNum: "SJOC-FUYS", desc: "Cinnamon - Stick" },
  { partNum: "7XE2-1WCP", desc: "Rice Wine - Aji Mirin" },
  { partNum: "75BY-J3EN", desc: "Avocado" },
  { partNum: "63VC-ZGSW", desc: "Tilapia - Fillets" },
  { partNum: "A869-ZDJE", desc: "Trout - Rainbow, Frozen" },
  { partNum: "5QNL-H2KD", desc: "Cheese - Colby" },
  { partNum: "Z7Y4-K47Q", desc: "Lobster - Base" }
]

export const FAKE_ADDRESSES = [
  { accountName: "Thoughtblab", firstName: "Murdoch", lastName: "Seamen", addressLine1: "2594 North Pass", addressLine2: "", city: "Brooklyn", state: "NY", postalCode: "11210", country: "US", phone: "718-157-6334" },
  { accountName: "Midel", firstName: "Hetty", lastName: "Netting", addressLine1: "476 Red Cloud Pass", addressLine2: "", city: "Wichita Falls", state: "TX", postalCode: "76310", country: "US", phone: "940-596-5036" },
  { accountName: "Kazio", firstName: "Ellis", lastName: "Mullaney", addressLine1: "196 Canary Alley", addressLine2: "", city: "Dallas", state: "TX", postalCode: "75205", country: "US", phone: "972-769-7763" },
  { accountName: "Skiba", firstName: "Vikky", lastName: "Mountain", addressLine1: "029 Thompson Court", addressLine2: "", city: "Houston", state: "TX", postalCode: "77025", country: "US", phone: "713-756-7091" },
  { accountName: "Quatz", firstName: "Shena", lastName: "Braybrooks", addressLine1: "85 Jay Alley", addressLine2: "", city: "Montgomery", state: "AL", postalCode: "36195", country: "US", phone: "334-664-8093" },
  { accountName: "Trunyx", firstName: "Laetitia", lastName: "Zannutti", addressLine1: "61 Browning Drive", addressLine2: "", city: "West Palm Beach", state: "FL", postalCode: "33416", country: "US", phone: "561-402-9757" },
  { accountName: "Fliptune", firstName: "Rollie", lastName: "Vispo", addressLine1: "76 Everett Pass", addressLine2: "", city: "Sarasota", state: "FL", postalCode: "34238", country: "US", phone: "941-237-5247" },
  { accountName: "Leenti", firstName: "Kaja", lastName: "Stitfall", addressLine1: "2236 Tennyson Park", addressLine2: "", city: "Philadelphia", state: "PA", postalCode: "19109", country: "US", phone: "610-482-5616" },
  { accountName: "Pixope", firstName: "Tarrance", lastName: "Adrain", addressLine1: "039 Dottie Plaza", addressLine2: "", city: "Hollywood", state: "FL", postalCode: "33028", country: "US", phone: "305-195-9654" },
  { accountName: "Zoovu", firstName: "Shaun", lastName: "Routledge", addressLine1: "509 Thackeray Alley", addressLine2: "", city: "Peoria", state: "IL", postalCode: "61614", country: "US", phone: "309-104-1404" },
  { accountName: "Browsebug", firstName: "Opalina", lastName: "Fry", addressLine1: "1702 Dennis Terrace", addressLine2: "", city: "Las Vegas", state: "NV", postalCode: "89178", country: "US", phone: "702-245-6635" },
  { accountName: "Livetube", firstName: "Val", lastName: "Grishechkin", addressLine1: "56363 Birchwood Terrace", addressLine2: "", city: "Las Vegas", state: "NV", postalCode: "89150", country: "US", phone: "702-149-2916" },
  { accountName: "Vinder", firstName: "Corinne", lastName: "Lawton", addressLine1: "57229 Mendota Drive", addressLine2: "", city: "Reading", state: "PA", postalCode: "19610", country: "US", phone: "610-994-4517" },
  { accountName: "Agivu", firstName: "Brook", lastName: "Beatty", addressLine1: "7920 Sycamore Avenue", addressLine2: "", city: "Lubbock", state: "TX", postalCode: "79491", country: "US", phone: "806-841-0341" },
  { accountName: "Janyx", firstName: "Shantee", lastName: "Goodding", addressLine1: "6 Eliot Place", addressLine2: "", city: "Manchester", state: "NH", postalCode: "03105", country: "US", phone: "603-468-8530" },
  { accountName: "Fivechat", firstName: "Torey", lastName: "Gogie", addressLine1: "7322 7th Hill", addressLine2: "", city: "Birmingham", state: "AL", postalCode: "35205", country: "US", phone: "205-980-4470" },
  { accountName: "Chatterpoint", firstName: "Fernanda", lastName: "Martinek", addressLine1: "9776 Comanche Center", addressLine2: "", city: "Mobile", state: "AL", postalCode: "36605", country: "US", phone: "251-713-5924" },
  { accountName: "Skyndu", firstName: "Link", lastName: "Masser", addressLine1: "31 Artisan Road", addressLine2: "", city: "Trenton", state: "NJ", postalCode: "08608", country: "US", phone: "609-884-4467" },
  { accountName: "Blogspan", firstName: "Rorke", lastName: "Hendin", addressLine1: "6 Barnett Pass", addressLine2: "", city: "Akron", state: "OH", postalCode: "44315", country: "US", phone: "330-947-3363" },
  { accountName: "Youopia", firstName: "Blaine", lastName: "Peer", addressLine1: "906 Dovetail Lane", addressLine2: "", city: "Sioux Falls", state: "SD", postalCode: "57198", country: "US", phone: "605-432-1665" },
  { accountName: "Jabbersphere", firstName: "Devlin", lastName: "Corrie", addressLine1: "4 Morrow Plaza", addressLine2: "", city: "Savannah", state: "GA", postalCode: "31416", country: "US", phone: "912-922-6607" },
  { accountName: "Yozio", firstName: "Morton", lastName: "Morecombe", addressLine1: "28 Oak Valley Alley", addressLine2: "", city: "San Diego", state: "CA", postalCode: "92105", country: "US", phone: "619-884-0827" },
  { accountName: "Feedmix", firstName: "Cecil", lastName: "Petrovsky", addressLine1: "97650 Prairieview Junction", addressLine2: "", city: "Grand Rapids", state: "MI", postalCode: "49544", country: "US", phone: "616-174-9916" },
  { accountName: "Zoombeat", firstName: "Gregorius", lastName: "Fowlston", addressLine1: "54 Miller Road", addressLine2: "", city: "Wichita Falls", state: "TX", postalCode: "76305", country: "US", phone: "940-900-8036" },
  { accountName: "Voonix", firstName: "Grover", lastName: "Morbey", addressLine1: "27163 Hintze Street", addressLine2: "", city: "Fresno", state: "CA", postalCode: "93740", country: "US", phone: "559-695-2474" },
  { accountName: "Jatri", firstName: "Janot", lastName: "Barabisch", addressLine1: "0 Kensington Hill", addressLine2: "", city: "Gatesville", state: "TX", postalCode: "76598", country: "US", phone: "254-490-8674" },
  { accountName: "Fanoodle", firstName: "Pier", lastName: "Slatcher", addressLine1: "5129 Barby Center", addressLine2: "", city: "Providence", state: "RI", postalCode: "02905", country: "US", phone: "401-664-5774" },
  { accountName: "Babbleopia", firstName: "Isidro", lastName: "Toombs", addressLine1: "2 Dahle Road", addressLine2: "", city: "Philadelphia", state: "PA", postalCode: "19178", country: "US", phone: "215-541-7835" },
  { accountName: "Gabvine", firstName: "Timi", lastName: "Clemenza", addressLine1: "21 Lakeland Alley", addressLine2: "", city: "Bronx", state: "NY", postalCode: "10454", country: "US", phone: "718-813-8243" },
  { accountName: "Mita", firstName: "Ruddie", lastName: "Giotto", addressLine1: "23564 Sachs Lane", addressLine2: "", city: "Pueblo", state: "CO", postalCode: "81005", country: "US", phone: "719-530-3147" },
  { accountName: "Fatz", firstName: "Isabelita", lastName: "Haggar", addressLine1: "0 Starling Way", addressLine2: "", city: "Jamaica", state: "NY", postalCode: "11407", country: "US", phone: "516-518-5741" },
  { accountName: "Latz", firstName: "Nicolea", lastName: "Larrie", addressLine1: "654 Cascade Trail", addressLine2: "", city: "Saint Petersburg", state: "FL", postalCode: "33705", country: "US", phone: "727-814-1327" },
  { accountName: "Bubbletube", firstName: "Andrej", lastName: "Poyser", addressLine1: "2 Alpine Crossing", addressLine2: "", city: "Indianapolis", state: "IN", postalCode: "46278", country: "US", phone: "317-314-4628" },
  { accountName: "Leexo", firstName: "Doy", lastName: "Cushion", addressLine1: "187 Manufacturers Parkway", addressLine2: "", city: "Washington", state: "DC", postalCode: "20599", country: "US", phone: "202-622-5247" },
  { accountName: "Feedbug", firstName: "Emmery", lastName: "Manvelle", addressLine1: "827 Grim Hill", addressLine2: "", city: "Reno", state: "NV", postalCode: "89510", country: "US", phone: "775-869-2192" },
  { accountName: "Plambee", firstName: "Joyous", lastName: "Oldmeadow", addressLine1: "90 Graedel Trail", addressLine2: "", city: "Pittsburgh", state: "PA", postalCode: "15266", country: "US", phone: "-636-7132" },
  { accountName: "Quire", firstName: "Lia", lastName: "Blazek", addressLine1: "6 Lyons Way", addressLine2: "", city: "Trenton", state: "NJ", postalCode: "08619", country: "US", phone: "609-119-1498" },
  { accountName: "Wordware", firstName: "Taylor", lastName: "Wynrahame", addressLine1: "91246 Shoshone Alley", addressLine2: "", city: "Flushing", state: "NY", postalCode: "11388", country: "US", phone: "917-365-3284" },
  { accountName: "Browsedrive", firstName: "Bondie", lastName: "Greenlees", addressLine1: "06 Hintze Way", addressLine2: "", city: "Hollywood", state: "FL", postalCode: "33028", country: "US", phone: "954-827-8153" },
  { accountName: "Gabspot", firstName: "Lonnard", lastName: "Lacroix", addressLine1: "38 Elgar Hill", addressLine2: "", city: "Pittsburgh", state: "PA", postalCode: "15255", country: "US", phone: "412-363-1485" },
  { accountName: "Lazzy", firstName: "Hedvige", lastName: "Tordiffe", addressLine1: "4874 Pawling Pass", addressLine2: "", city: "Akron", state: "OH", postalCode: "44329", country: "US", phone: "330-752-6825" },
  { accountName: "Youfeed", firstName: "Elke", lastName: "Inglesfield", addressLine1: "0 Pleasure Lane", addressLine2: "", city: "West Palm Beach", state: "FL", postalCode: "33405", country: "US", phone: "772-685-8771" },
  { accountName: "Bubblebox", firstName: "Shanie", lastName: "Coners", addressLine1: "73 Mccormick Hill", addressLine2: "", city: "Las Vegas", state: "NV", postalCode: "89105", country: "US", phone: "702-269-4811" },
  { accountName: "Realblab", firstName: "Felike", lastName: "Esbrook", addressLine1: "95 Ronald Regan Hill", addressLine2: "", city: "Columbus", state: "OH", postalCode: "43268", country: "US", phone: "614-543-0601" },
  { accountName: "Wordify", firstName: "Glennie", lastName: "Morando", addressLine1: "99453 Pond Way", addressLine2: "", city: "Richmond", state: "VA", postalCode: "23277", country: "US", phone: "804-788-7721" },
  { accountName: "Quaxo", firstName: "Dale", lastName: "Beton", addressLine1: "619 Hauk Court", addressLine2: "", city: "Augusta", state: "GA", postalCode: "30919", country: "US", phone: "706-462-7125" },
  { accountName: "Zoomdog", firstName: "Xerxes", lastName: "Kinnier", addressLine1: "785 Thackeray Way", addressLine2: "", city: "Bozeman", state: "MT", postalCode: "59771", country: "US", phone: "406-207-6450" },
  { accountName: "Linkbridge", firstName: "Averell", lastName: "Hand", addressLine1: "2 Springs Alley", addressLine2: "", city: "Amarillo", state: "TX", postalCode: "79182", country: "US", phone: "806-172-4117" },
  { accountName: "Fivechat", firstName: "Tine", lastName: "Skoughman", addressLine1: "71 Arrowood Alley", addressLine2: "", city: "Atlanta", state: "GA", postalCode: "30368", country: "US", phone: "404-414-7249" },
  { accountName: "Kwimbee", firstName: "Powell", lastName: "Zarfai", addressLine1: "404 Huxley Drive", addressLine2: "", city: "Midland", state: "TX", postalCode: "79710", country: "US", phone: "432-541-6948" },
  { accountName: "Tagchat", firstName: "Luz", lastName: "Faulkener", addressLine1: "726 Graedel Point", addressLine2: "", city: "Boulder", state: "CO", postalCode: "80328", country: "US", phone: "303-161-9532" },
  { accountName: "Buzzbean", firstName: "Daron", lastName: "Jerwood", addressLine1: "23 Lien Alley", addressLine2: "", city: "Garden Grove", state: "CA", postalCode: "92844", country: "US", phone: "310-781-1653" },
  { accountName: "Photobug", firstName: "Way", lastName: "Blount", addressLine1: "71031 Lerdahl Place", addressLine2: "", city: "Bronx", state: "NY", postalCode: "10454", country: "US", phone: "718-898-2714" },
  { accountName: "Shufflester", firstName: "Cedric", lastName: "Joris", addressLine1: "5 Lotheville Center", addressLine2: "", city: "Los Angeles", state: "CA", postalCode: "90045", country: "US", phone: "310-677-6171" },
  { accountName: "Janyx", firstName: "Trista", lastName: "Ahrendsen", addressLine1: "58487 Heffernan Terrace", addressLine2: "", city: "Norman", state: "OK", postalCode: "73071", country: "US", phone: "405-560-0873" },
  { accountName: "Brightbean", firstName: "Sal", lastName: "Rittmeier", addressLine1: "856 Reindahl Trail", addressLine2: "", city: "Pomona", state: "CA", postalCode: "91797", country: "US", phone: "909-941-4159" },
  { accountName: "Topiclounge", firstName: "Ameline", lastName: "Woolfall", addressLine1: "41 Sundown Drive", addressLine2: "", city: "Topeka", state: "KS", postalCode: "66611", country: "US", phone: "785-646-9216" },
  { accountName: "Roombo", firstName: "Boothe", lastName: "Warrillow", addressLine1: "9 Toban Trail", addressLine2: "", city: "Lexington", state: "KY", postalCode: "40515", country: "US", phone: "859-137-3781" },
  { accountName: "Divanoodle", firstName: "Sharron", lastName: "Watson", addressLine1: "93 Oak Terrace", addressLine2: "", city: "Sandy", state: "UT", postalCode: "84093", country: "US", phone: "801-412-8977" },
  { accountName: "Twitterwire", firstName: "Beauregard", lastName: "Bennen", addressLine1: "3611 Lerdahl Point", addressLine2: "", city: "San Diego", state: "CA", postalCode: "92176", country: "US", phone: "619-291-0296" },
  { accountName: "Teklist", firstName: "Faina", lastName: "Aldrick", addressLine1: "7703 Memorial Place", addressLine2: "", city: "Louisville", state: "KY", postalCode: "40220", country: "US", phone: "502-954-7208" },
  { accountName: "Youbridge", firstName: "Tallie", lastName: "Matelyunas", addressLine1: "17 International Hill", addressLine2: "", city: "Hartford", state: "CT", postalCode: "06160", country: "US", phone: "860-586-3830" },
  { accountName: "Ntag", firstName: "Padraig", lastName: "Lathleiffure", addressLine1: "57 Westridge Point", addressLine2: "", city: "Vancouver", state: "WA", postalCode: "98682", country: "US", phone: "360-179-5041" },
  { accountName: "Skinder", firstName: "Ceciley", lastName: "Blackwell", addressLine1: "174 Chive Point", addressLine2: "", city: "Jamaica", state: "NY", postalCode: "11499", country: "US", phone: "212-781-3635" }
]

export const FAKE_TEXT = [
	"Vestibulum accumsan neque et nunc. Quisque ornare tortor at risus. Nunc ac sem ut dolor",
	"elit. Curabitur sed tortor. Integer aliquam adipiscing lacus. Ut nec urna et arcu imperdiet ullamcorper.",
	"nascetur ridiculus mus. Aenean eget magna. Suspendisse tristique neque venenatis lacus. Etiam bibendum fermentum metus.",
	"a mi fringilla mi lacinia mattis. Integer eu lacus. Quisque imperdiet, erat nonummy ultricies ornare,",
	"vitae dolor. Donec fringilla. Donec feugiat metus sit amet ante. Vivamus non lorem vitae odio",
  "eu nibh vulputate mauris sagittis placerat. Cras dictum ultricies ligula. Nullam enim. Sed nulla ante,",
	"a, enim. Suspendisse aliquet, sem ut cursus luctus, ipsum leo elementum sem, vitae aliquam eros",
	"sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec dignissim magna a",
	"fringilla euismod enim. Etiam gravida molestie arcu. Sed eu nibh vulputate mauris sagittis placerat. Cras",
	"metus. In nec orci. Donec nibh. Quisque nonummy ipsum non arcu. Vivamus sit amet risus.",
  "convallis dolor. Quisque tincidunt pede ac urna. Ut tincidunt vehicula risus. Nulla eget metus eu",
	"non, egestas a, dui. Cras pellentesque. Sed dictum. Proin eget odio. Aliquam vulputate ullamcorper magna.",
	"magna sed dui. Fusce aliquam, enim nec tempus scelerisque, lorem ipsum sodales purus, in molestie",
	"tincidunt congue turpis. In condimentum. Donec at arcu. Vestibulum ante ipsum primis in faucibus orci",
	"lectus rutrum urna, nec luctus felis purus ac tellus. Suspendisse sed dolor. Fusce mi lorem,",
  "in lobortis tellus justo sit amet nulla. Donec non justo. Proin non massa non ante",
	"vel quam dignissim pharetra. Nam ac nulla. In tincidunt congue turpis. In condimentum. Donec at",
	"vulputate velit eu sem. Pellentesque ut ipsum ac mi eleifend egestas. Sed pharetra, felis eget",
	"quis diam. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
	"amet, dapibus id, blandit at, nisi. Cum sociis natoque penatibus et magnis dis parturient montes,",
  "ullamcorper. Duis at lacus. Quisque purus sapien, gravida non, sollicitudin a, malesuada id, erat. Etiam",
	"faucibus leo, in lobortis tellus justo sit amet nulla. Donec non justo. Proin non massa",
	"imperdiet dictum magna. Ut tincidunt orci quis lectus. Nullam suscipit, est ac facilisis facilisis, magna",
	"sagittis felis. Donec tempor, est ac mattis semper, dui lectus rutrum urna, nec luctus felis",
	"interdum ligula eu enim. Etiam imperdiet dictum magna. Ut tincidunt orci quis lectus. Nullam suscipit,"
]

export const FAKE_EMAIL_ADDRESSES = [
  "daniele.mcintosh@ymail.com",
  "2jyomnmqs6017@yahoo.com",
  "johnson.craig@gmail.com",
  "qtddd08po971z5s@hotmail.com",
  "reean.whitfield@ymail.com",
  "fzjdv37f4bt9piklobwd@comcast.net",
  "rasmus.fletcher@gmail.com",
  "477cqdazrk9o9lrzam@msn.com",
  "peregrine.forbes@comcast.net",
  "vivvi1h8zqr4ffjxzu@comcast.net",
  "kalvin.hopper@hotmail.com",
  "2f9acx6fjezwbm@outlook.com",
  "beinn.wise@msn.com",
  "qczjjcxk1pxwsa477gru@rediffmail.com",
  "nicolae.roman@aol.com",
  "kxwm3tdfumt0vpghs@aol.com",
  "mikee.tillman@comcast.net",
  "2f3rrtucxoamguox08d7@aol.com",
  "parker.dixon@outlook.com",
  "msvd4yaehhr3ilx2mrr@rediffmail.com",
  "karol.hunt@hotmail.com",
  "5rn75obe45uvb69a@yahoo.com",
  "kyel.christensen@yahoo.com",
  "cxi8txr7p7px6j@ymail.com",
  "diarmaid.bradshaw@gmail.com"
]

export const fakeProject = (list = FAKE_PROJECTS) => random(list);
export const fakeMaterial = (list = FAKE_MATERIALS) => random(list);
export const fakeAddress = (list = FAKE_ADDRESSES) => random(list);
export const fakeText = (list = FAKE_TEXT, limit) => {
  let text =  random(list);
  if (limit) text = text.split(' ').slice(0, limit).join(' ');
  return text
};
export const getFakeEmail = (list = FAKE_EMAIL_ADDRESSES) => random(list);

export const maskOrder = (order, overrides = {}) => {
  return {
    ...order,
    wmsProjectLookupCode_demo: fakeProject().value,
    shipFromAccountName_demo: fakeAddress().accountName,
    shipToName_demo: fakeAddress().accountName,
    salesChannel_demo: (() => order.salesChannel && fakeProject().label)(),
    whqNote_demo: (() => {
      if (order.whqNote) {
        return {
          ...order.whqNote,
          noteData: fakeText()
        }
      }
    })(),
    ...overrides
  }
}

export const maskLoad = (load, overrides = {}) => {
  return {
    ...load,
    wmsProjectLookupCode_demo: fakeProject().value,
    loadDescription_demo: load.loadDescription && fakeText(undefined, 7),
    salesChannels_demo: load.salesChannels?.map(() => fakeProject().label),
    loadNote_demo: (() => {
      if (load.loadNote) {
        return {
          ...load.loadNote,
          noteData: fakeText()
        };
      }
    })(),
    ...overrides
  };
};